import Head from "next/head";
import ListingPagesHeplerWrapper from "pagesHelpers/ListingPagesHepler/ListingPagesHelperWrapper";
import { getServerSidePropsHelperSSR } from "pagesHelpers/ListingPagesHepler/vMAP";
import { wrapper } from "redux/configureStore";

const transaction_type = "Location";
const RendringPage = ({ url }) => {
  return (
    <>
      <Head>
        <meta name="robots" content="noindex, nofollow" />
        <link
          href="https://api.mapbox.com/mapbox-gl-js/v2.7.0/mapbox-gl.css"
          rel="stylesheet"
        />
        <link
          href="https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-geocoder/v4.2.0/mapbox-gl-geocoder.css"
          rel="stylesheet"
        />
      </Head>

      <ListingPagesHeplerWrapper
        transaction_type={transaction_type}
        url={url}
      />
    </>
  );
};

export const getServerSideProps = wrapper.getServerSideProps((store) => {
  return async ({
    req,
    res,
    params,
    query,
    resolvedUrl,
  }: {
    req?: any;
    res?: any;
    params?: any;
    query?: any;
    resolvedUrl?: any;
  }) => {
    res.setHeader("Cache-Control", "public, max-age=86400");

    let ssr_data = await getServerSidePropsHelperSSR(
      store,
      req,
      query,
      query.transaction_type ? query.transaction_type : transaction_type,
      "Listings",
      "MAP",
      null,
      query
    );
    return ssr_data.notFound
      ? {
          notFound: true,
        }
      : {
          props: {
            url: resolvedUrl,
          },
        };
  };
});

export default RendringPage;
